import { render, staticRenderFns } from "./targetIndicators.vue?vue&type=template&id=7dc915a2&scoped=true&"
import script from "./targetIndicators.vue?vue&type=script&lang=ts&"
export * from "./targetIndicators.vue?vue&type=script&lang=ts&"
import style0 from "./targetIndicators.vue?vue&type=style&index=0&id=7dc915a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc915a2",
  null
  
)

export default component.exports